import { render } from "./OrderList.vue?vue&type=template&id=68dd9b98"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=68dd9b98&lang=css"

import exportComponent from "/var/www/html2/esmanage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__